import BaseMap from 'components/BaseMap/BaseMap';
import {
  SEVERE_WEATHER_ALERTS_DEFAULT_CENTER,
  SEVERE_WEATHER_ALERTS_DEFAULT_ZOOM,
} from '../../config/severeWeatherAlerts.config';
import SevereWeatherAlertMapLayers from './components/SevereWeatherAlertMapLayers/SevereWeatherAlertMapLayers';

const SevereWeatherAlertMapContent = ({
  areas = [],
  selectedArea,
  fallbackCenter,
  onSelectArea,
  scrollZoom = true,
}) => {
  const mapCenter = selectedArea?.center ?? fallbackCenter ?? SEVERE_WEATHER_ALERTS_DEFAULT_CENTER;

  return (
    <div className="severe-weather-alert-map position-relative d-flex h-100 min-h-0 w-100 overflow-hidden rounded-2">
      <BaseMap
        mapCenter={mapCenter}
        bounds={selectedArea?.bounds ?? null}
        zoom={SEVERE_WEATHER_ALERTS_DEFAULT_ZOOM}
        preserveLocationZoom
        scrollZoom={scrollZoom}
      >
        <SevereWeatherAlertMapLayers
          areas={areas}
          selectedAreaId={selectedArea?.id}
          onSelectArea={onSelectArea}
        />
      </BaseMap>
    </div>
  );
};

export default SevereWeatherAlertMapContent;
